<smw-select
  #collaboratorSelect
  formControlName="collaborators"
  [placeholder]="'dashboard-manager_create-conversation_collaborators_placeholder' | translate"
  [multiple]="true"
  [trackBy]="'email'"
>
  @for (option of collaboratorOptions(); track option.value.email) {
    <smw-select-option
      [option]="option"
      (checkedChange)="updateSelectedCollaborators(option.value, $event)"
    />
  }
  <div class="invite-collab">
    @if (!showCustomEmailCollabField()) {
      <span (click)="displayCustomCollaboratorField($event)">
        {{ 'conversations_create_collaborator' | translate }}
      </span>
    } @else {
      <input
        type="email"
        [placeholder]="'conversations_create_collaborator_email_placeholder' | translate"
        (keydown.enter)="addCollaboratorOption($event)"
      />
    }
  </div>
</smw-select>
